const pendingScripts = new Map();

export function loadExternalScript(src, { id } = {}) {
  if (typeof document === 'undefined') {
    return Promise.reject(new Error('Cannot load scripts on the server'));
  }

  if (pendingScripts.has(src)) {
    return pendingScripts.get(src);
  }

  const existing = id
    ? document.getElementById(id)
    : document.querySelector(`script[src="${src}"]`);

  if (existing) {
    if (existing.getAttribute('data-loaded') === 'true') {
      return Promise.resolve();
    }
    const promise = new Promise((resolve, reject) => {
      existing.addEventListener('load', () => {
        existing.setAttribute('data-loaded', 'true');
        resolve();
      }, { once: true });
      existing.addEventListener('error', () => {
        reject(new Error(`Failed to load script: ${src}`));
      }, { once: true });
    });
    pendingScripts.set(src, promise);
    return promise;
  }

  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (id) script.id = id;
    script.onload = () => {
      script.setAttribute('data-loaded', 'true');
      resolve();
    };
    script.onerror = () => {
      pendingScripts.delete(src);
      reject(new Error(`Failed to load script: ${src}`));
    };
    document.head.appendChild(script);
  });

  pendingScripts.set(src, promise);
  return promise;
}

export function scheduleIdle(callback, timeout = 3000) {
  if (typeof window === 'undefined') return () => {};

  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(callback, { timeout });
    return () => window.cancelIdleCallback(id);
  }

  const id = window.setTimeout(callback, 1);
  return () => window.clearTimeout(id);
}

export const RAZORPAY_SCRIPT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';

export function loadRazorpayCheckout() {
  if (typeof window !== 'undefined' && window.Razorpay) {
    return Promise.resolve();
  }
  return loadExternalScript(RAZORPAY_SCRIPT_SRC);
}
